<template>
<div class="columns is-centered">
  <div class="column is-half">

    <div class="card">
      <header class="card-header">
        <p class="card-header-title">
          Convert Units
        </p>
      </header>

      <div class="card-content">
        <div class="content">
          <p>
            List of Units that are converted from one to the other.
            This is for when you buy a product in one unit and apply it in another.
            For example, buy fertilizer by the ton but apply it by the pound.
            Having a way to convert the units allows you to just enter the prices as you would buy the product, and the app then does conversion when you apply it.
          </p>

          <section>
            <b-table
              :data="convertUnitItemsList"
              :paginated="isPaginated"
              :per-page="perPage"
              :current-page.sync="currentPage"
              :pagination-simple="isPaginationSimple"
              :default-sort-direction="defaultSortDirection"
              default-sort="description">

              <template slot-scope="props">
                <b-table-column field="fromUnit" label="From Units" sortable>
                  {{ props.row.fromUnit }}
                </b-table-column>

                <b-table-column field="toUnit" label="To Units" sortable>
                  {{ props.row.toUnit }}
                </b-table-column>

                <b-table-column field="quantity" label="Quantity" sortable numeric>
                  <span class="bote-number">{{ props.row.quantity }}</span>
                </b-table-column>

              </template>
            </b-table>
          </section>

        </div>
      </div>
      <footer class="card-footer">
      </footer>
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ConvertUnitList',
  data () {
    return {
      isPaginated: true,
      isPaginationSimple: false,
      defaultSortDirection: 'asc',
      currentPage: 1,
      perPage: 25
    }
  },
  computed: {
    ...mapGetters([
      'convertUnitItemsList'
    ])
  }
}

</script>

<style scoped>
span.bote-number {
    font-family: monospace
}
</style>
